export enum ModalQuestaoAcaoEnum{
    SIM,
    NAO,
    CANCELAR,
    SALVAR,
    NOVA_REVISAO
}